
import React, { useState, useEffect } from 'react';
import "react-responsive-carousel/lib/styles/carousel.min.css";
import * as Request from '../../common/request';
import Page from '../../components/page';

import './index.less';

const PageModel = props => {
	const [list, setList] = useState([]);
	const getList = async () => {
		const result = await Request.get({
			url: '/user/shops'
		});
		if (!result) return;

		setList(result.data || []);
	};
	useEffect(() => {
		getList();
	}, [ 123 ]);

	return (
		<Page title="店铺列表">
			<section className="devices-container" style={{ minHeight: window.innerHeight - 50 }}>
				{list && list.length > 0 && list.map((item,index)=>{
					return (
						<div className="devices-content" key={index} onClick={() => props.history.push('/devices/'+item.id+'/'+item.userId)}>
							<div className='device-item'>{item.companyName}</div>
							<div className='device-address'>{item.address}</div>
						</div>
						)
					})
				}
				{
					list.length === 0 && <div className="no-data">暂无绑定任何店铺数据</div>
				}
				
			</section>
		</Page>
	);
};

export default PageModel;
